module.exports = __webpack_public_path__ + "img/logo_mf_en.b93f5111.png";